import { CategorySummary } from '@cart/shared-types';

export const CATEGORIES: CategorySummary[] = [
  {
    id: 'cat-bags',
    name: 'Bags',
    slug: 'bags',
    parentId: null,
    level: 0,
    productCount: 1,
    totalProductCount: 1,
    createdAt: '2026-05-01T09:00:00.000Z',
  },
  {
    id: 'cat-kitchen',
    name: 'Kitchen',
    slug: 'kitchen',
    parentId: null,
    level: 0,
    productCount: 2,
    totalProductCount: 2,
    createdAt: '2026-05-02T09:00:00.000Z',
  },
  {
    id: 'cat-workspace',
    name: 'Workspace',
    slug: 'workspace',
    parentId: null,
    level: 0,
    productCount: 1,
    totalProductCount: 1,
    createdAt: '2026-05-03T09:00:00.000Z',
  },
];
